// -*-mode: rjsx -*-

// MUI
import { makeStyles, createStyles } from '@material-ui/core/styles';

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"

const globalStyles = theme => createStyles({
    test1Root: {
        color: theme.palette.test.fg1,
        background: theme.palette.test.bg1,
    },

    testRoot: {
        color: theme.palette.test.fg2,
        background: theme.palette.test.bg2,
    },

    testDiv: {
        color: theme.palette.test.fg2,
        background: theme.palette.test.bg2,
    },

    // relative to the whole viewport
    centerDiv_viewport: {
        // display: "flex",
        //        flexDirection: "row",
        width: "50vw",
        height: "50vh",
        marginLeft: "25vw",
        marginRight: "25vw",
        marginTop: "25vw",
        marginBottom: "25vw",

        color: theme.palette.test.fg3,
        background: theme.palette.test.bg3,
    },
    // relative to the visible window
    centerDiv_relative: {
        // display: "flex",
        //        flexDirection: "row",
        width: "50%",
        height: "50%",
        marginLeft: "25%",
        marginRight: "25%",
        marginTop: "50%",
        marginBottom: "25%",

        color: theme.palette.test.fg3,
        background: theme.palette.test.bg3,
    },

    // he main trick in this demo is that in the normal flow of elements going from top to bottom, so the margin-top: auto is set to zero.
        
    // center both relative and static 200px
    centerDiv_works_totalCenter: {

	position: "absolute",
	top:0,
	bottom: 0,
	left: 0,
	right: 0,
  	
	margin: "auto",

//      width: 200,
//	height: 200,

        width: "50%",
	height: "50%",

        color: theme.palette.test.fg3,
        background: theme.palette.test.bg3,
    },

    centerDiv: {

	position: "absolute",
	top:0,
	bottom: 0,
	left: 0,
	right: 0,
  	
	margin: "auto",

//      width: 200,
//	height: 200,

//        width: "50%",
//	height: "50%",
        
//        color: theme.palette.test.fg3,
//        background: theme.palette.test.bg3,
    },

    elementDiv_works_RelativeCenter: {

	position: "absolute",
	top:0,
	bottom: 0,
	left: 0,
	right: 0,
  	
	margin: "auto",

//      width: 200,
//	height: 200,

        width: "50%",
	height: "50%",
        
        color: theme.palette.test.fg2,
        background: theme.palette.test.bg2,
    },


    elementDiv_works_InCorner: {
        
	position: "absolute",
//	top:100,
	bottom: 20, 
//	left: 0,
	right: 20,
  	
	margin: "auto",

//      width: 200,
//	height: 200,

//        width: "50%",
//	height: "50%",
        
        color: theme.palette.test.fg2,
        background: theme.palette.test.bg2,
    },


    fabRightCornerDiv: {
	position: "absolute",
	bottom: 20, 
	right: 20,
  	
	margin: "auto",
    },
    
    
})

// hook to use in functions
const useGlobalStyles = makeStyles(globalStyles, { name: "globalStyles" } )

export {
    globalStyles, // for use in components
    useGlobalStyles // for use in hooks
}
